// ══════════════════════════════════════════════
//  角色工具：企业角色（仅企业视角，经营看板）
//  企业角色可见范围由页面决定：
//    - 方案概况 / 订单概况：本企业 + 合作企业
//    - 设备概况：仅本企业
// ══════════════════════════════════════════════

// 读取当前登录用户信息（原型阶段从 localStorage 读取，联调时替换为接口）
const getUserInfo = () => {
    try {
        return JSON.parse(localStorage.getItem('user_info') || '{}');
    } catch (e) {
        return {};
    }
};

// 本企业 ID
export const getMyEntId = () => {
    const info = getUserInfo();
    return info?.ent_id || 'test-ent-a';
};

// 合作企业 ID 列表
export const getCoopEntIds = () => {
    const info = getUserInfo();
    return info?.coop_ent_ids || [];
};

// 可见的企业 ID 范围 = 本企业 + 合作企业
export const getVisibleEntIds = () => {
    return [getMyEntId(), ...getCoopEntIds()];
};

// 过滤：本企业 + 合作企业（方案概况 / 订单概况用）
export const filterVisibleEnts = (all) => {
    const visibleIds = getVisibleEntIds();
    return all.filter((e) => visibleIds.includes(e.value));
};

// 过滤：仅本企业（设备概况用，不涉及合作企业）
export const filterMyEntOnly = (all) => {
    const myId = getMyEntId();
    return all.filter((e) => e.value === myId);
};

// 判断某企业是否为"本企业"
export const isMyEnt = (entId) => {
    return entId === getMyEntId();
};

// 各统计页的企业角色本企业与合作企业（mock 用，联调时替换为接口返回）
export const SCOPE_ENT_MAP = {
    solution: { ent_id: 'test-ent-sol-a', coop_ent_ids: ['test-ent-sol-b'], label: '本企业 + 合作企业' },
    produce: { ent_id: 'test-ent-mfg-a', coop_ent_ids: [], label: '仅本企业' },
    app: { ent_id: 'test-ent-app-a', coop_ent_ids: ['test-ent-app-b'], label: '本企业 + 合作企业' },
};

// 企业角色预设
export const MOCK_ROLE_PRESETS = {
    enterprise: { label: '企业角色', role: 'enterprise' },
};

// 设置企业角色（原型演示用）：scope 决定本企业与合作企业，写入后生效
export const setRolePreset = (key, scope) => {
    const preset = MOCK_ROLE_PRESETS[key];
    if (!preset) return;
    const ent = SCOPE_ENT_MAP[scope] || {};
    localStorage.setItem('user_info', JSON.stringify({
        ...preset,
        ent_id: ent.ent_id,
        coop_ent_ids: ent.coop_ent_ids || [],
    }));
};
